<template>
  <transition name="fade">
    <div v-if="show" :class="rootClass" class="company-root">
      <div class="sp-section first">
        <div class="bgs">
          <div :style="bg5Style" class="bg bg5"></div>
          <div :style="bg6Style" class="bg bg6"></div>
        </div>
      </div>

      <div class="sp-section second">
        <div class="texts">
          <div class="text text1">
            <dl>
              <dt :style="text1TitleStyle">
                社名
                <br />
                代表社員
              </dt>
              <dd :style="text1ContentStyle">
                合同会社ＮＧＳ
                <br />
                森岡昭臣
              </dd>
            </dl>
          </div>

          <div :style="text2Style" class="text text2">
            <dl>
              <dt>世田谷本社</dt>
              <dd>
                〒１５４-００２３
                <br />
                東京都世田谷区若林３丁目２０-１７ 芳和荘２０２号
                <br />
                ＴＥＬ ０３・６４５０・８６８０
                <br />
                ＦＡＸ ０３・６４５０・８７２１
              </dd>
            </dl>
          </div>

          <div class="text text3">
            <dl>
              <dt :style="text3TitleStyle">高知パーク</dt>
              <dd :style="text3ContentStyle">
                〒７８１-５６０２
                <br />
                高知県香南市夜須町千切５３７-９０ 道の駅やすＥ棟
                <br />
                ＴＥＬ ０８８７・５２・８８４４
                <br />
                ＦＡＸ ０８８７・５２・８８４５
              </dd>
            </dl>
          </div>

          <div :style="text45Style" class="text text4">
            <dl>
              <dt>取引銀行</dt>
              <dd>世田谷信用金庫、四国銀行</dd>
            </dl>
          </div>

          <div :style="text45Style" class="text text5">
            <dl>
              <dt>主要取引先</dt>
              <dd>
                スタークス株式会社
                <br />
                And One Software Engineering株式会社
                <br />
                株式会社エムズサイエンス
                <br />
                新大和漢方株式会社
                <br />
                アミフィアブル株式会社
                <br />
                株式会社メタリテール・コンサルティング
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  spFadeStyle1,
  spTransformStyle1,
  spFadeStyle2,
  spTransformStyle2
} from '../../lib/spStyleGenerator'

export default {
  name: 'pageSpConcept',

  computed: {
    rootClass() {
      return this.scrollRate <= 0.5 ? 'first' : 'second'
    },

    show() {
      const currentPage = this.$store.getters.currentPage

      return currentPage === 'company'
    },

    scrollRate() {
      return this.$store.getters.companyPageRate
    },

    text1TitleStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 50 })
      }
    },

    text1ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: -70, scale: 3 }),
        ...spFadeStyle2(this.scrollRate, 2)
      }
    },

    text2Style() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 100 })
      }
    },

    text3TitleStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 100 })
      }
    },

    text3ContentStyle() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: -50, scale: 0.5 }),
        ...spFadeStyle2(this.scrollRate, 2, 0.2)
      }
    },

    text45Style() {
      return {
        ...spTransformStyle2(this.scrollRate, { y: 100 })
      }
    },

    bg5Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { x: 200 })
      }
    },

    bg6Style() {
      return {
        ...spTransformStyle1(this.scrollRate, { y: -200 }),
        ...spFadeStyle1(this.scrollRate, 4)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.bgs
  overflow-x: hidden
  height: 600px
  position: relative

.bg
  position: absolute
  background-size: cover
  width: 250px
  height: 375px
  &5
    left: 127px
    top: 178px
    background-image: url('/images/bg/bg5.jpg')
  &6
    left: -20px
    top: 80px
    background-image: url('/images/bg/bg6.jpg')

.texts
  position: absolute
  width: 100%
  height: 600px
  top: 80px
  left: 0
  font-size: 10px
  letter-spacing: 2.5px
  .text
    -ms-writing-mode: tb-rl
    writing-mode: vertical-rl
    position: absolute
    dl
      dt, dd
        display: inline-block
      dt
        height: 70px
        vertical-align: top
      dd
        margin-top: 0
        letter-spacing: 1.5px

    &.text1
      top: 0
      right: 0

    &.text2
      top: 0
      right: 40px

    &.text3
      top: 50px
      right: 110px

    &.text4
      top: 100px
      right: 180px

    &.text5
      top: 100px
      right: 210px
</style>
